import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import '@/assets/style/base.css'
import router from './router'
import "babel-polyfill"
import store from './store'
import { showLoading, hideLoading } from './utils/loading';
// import ElementUI from 'element-ui';
import {post} from '@/config/axios'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueQriously from 'vue-qriously'
// import utils from './utils/public.js'

Vue.config.productionTip = false;
Vue.prototype.$post=post;
Vue.prototype.$store=store;
Vue.prototype.showLoading=showLoading;
Vue.prototype.hideLoading=hideLoading;
// Vue.prototype.public = utils;
Vue.use(VueQuillEditor);
Vue.use(VueQriously);

Storage.prototype.setExpire=(key, value, expire) =>{
  let obj={
    data:value,
    time:Date.now(),
    expire:expire
  };
  localStorage.setItem(key,JSON.stringify(obj));
};

Storage.prototype.getExpire= key =>{
  let val =localStorage.getItem(key);
  if(!val){
    return val;
  }
  val =JSON.parse(val);
  if(Date.now()-val.time>val.expire){
    localStorage.removeItem(key);
    return null;
  }
  return val.data;
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');


